export enum ApprovalRoleCode {
  Manager = 'MANAGER',
  Director = 'DIRECTOR',
  EmployeesManager = 'EMPLOYEES_MANAGER',
  EmployeesDirector = 'EMPLOYEES_DIRECTOR',
}
